import { memo } from 'react'
import { BaseEdge, EdgeProps } from '@xyflow/react'
import { useWorkflowStore, WorkflowEdgeData } from '@store/workflowStore'
import { buildWaypointPath, computeAnchors, computeSegments } from './waypointPath'
import { WaypointAnchors } from './WaypointAnchors'

function WaypointEdgeInner(props: EdgeProps) {
  const {
    id,
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    style,
    markerEnd,
    data,
    selected,
    interactionWidth,
  } = props

  const edgeData = (data ?? {}) as WorkflowEdgeData
  const waypoints = edgeData.waypoints ?? []
  const isRouteEdge = !!edgeData.isRouteEdge
  const isLoadingWorkflow = useWorkflowStore((s) => s.isLoadingWorkflow)

  const { path, orthoPoints } = buildWaypointPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    waypoints,
    borderRadius: 8,
  })

  // Route edges keep their existing rendering and do not show waypoint anchors (deferred feature).
  const showAnchors = selected && !isRouteEdge && !isLoadingWorkflow

  const anchors = computeAnchors(
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    waypoints
  )

  const segments = showAnchors
    ? computeSegments(orthoPoints, sourceX, sourceY, targetX, targetY, waypoints)
    : []

  return (
    <>
      <BaseEdge
        id={id}
        path={path}
        style={style}
        markerEnd={markerEnd}
        interactionWidth={interactionWidth ?? 20}
      />
      {showAnchors && (
        <WaypointAnchors
          edgeId={id}
          sourceX={sourceX}
          sourceY={sourceY}
          targetX={targetX}
          targetY={targetY}
          waypoints={waypoints}
          anchors={anchors}
          segments={segments}
        />
      )}
    </>
  )
}

export const WaypointEdge = memo(WaypointEdgeInner)
